<div id="head"><slot name="head"></slot></div>
<div id="body">
  <div id="content">
    <div id="nav-top"><slot name="nav-top"></slot></div>
    <div id="main" part="main"><slot name="main"></slot></div>
    <div id="nav-bottom"><slot name="nav-bottom"></slot></div>
  </div>
  <div id="side-start" part="side-start" class="hidden"><slot name="side-start"></slot></div>
  <div id="side-end" part="side-end" class="hidden"><slot name="side-end"></slot></div>
</div>
<div id="foot"><slot name="foot"></slot></div>
